const CellTDRefillAmt: React.FC<{ data: any }> = ({ data }) => {

    return (
        <><small>Last: {data['last_refill_amount']}</small><br /><small>Current: {data['current_refill_amount']}</small></>
    )
}

export default CellTDRefillAmt;